import React, { useEffect, useState } from "react";
import { authAxios } from "../utils/axiosConfig";
import { toast } from "sonner";
import { useDispatch } from "react-redux";
import { fetchUsers } from "../redux/usersSlice";
import "../styles/dashboardEditUser.css";

const ModalEditUser = ({ userInfo, showEditModal }) => {
	const [formData, setFormData] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		if (userInfo) {
			setFormData({ ...userInfo });
		}
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleEditSubmit = async (e) => {
		e.preventDefault();
		
		if (!formData._id) {
			toast.error("User ID is missing!");
			return;
		}
		
		try {
			const response = await authAxios.put(`/api/users/${userInfo._id}`, formData);
			if (response.status === 200) {
				showEditModal()
				dispatch(fetchUsers())
				toast.success("User updated successfully!");
			}
		} catch (error) {
			const errorMessage = error.response?.data?.message;
			console.error(error, errorMessage);
			toast.error("Failed to update user. " + errorMessage);
		} finally {
		}
	};

	return (
		<div
			role="dialog"
			aria-modal="true"
			className="dashboard_edit_modal"
		>
			<form
				onSubmit={handleEditSubmit}
				className="dashboard_edit_user_form"
			>
				<h2 className="sub_title">Update User</h2>
				<button
					type="button"
					className="modal_close_btn"
					onClick={() => showEditModal()}
				>
					X
				</button>

				<div className="dashboard_input_wrapper">
					<div className="name_wrapper">
						<label>
							Firstame:
							<input
								type="text"
								name="firstname"
								value={formData.firstname || ""}
								onChange={handleChange}
								className="input_area"
								placeholder="Enter your firstname"
								required
							/>
						</label>
						<label>
							Lastname:
							<input
								type="text"
								name="lastname"
								value={formData.lastname || ""}
								onChange={handleChange}
								className="input_area"
								placeholder="Enter your lastname"
								required
							/>
						</label>
					</div>
					<label>
						Email:
						<input
							type="email"
							name="email"
							value={formData.email || ""}
							onChange={handleChange}
							className="input_area"
							placeholder="Enter your email"
							required
						/>
					</label>

					<label>
						Gender:
						<select
							id="gender"
							name="gender"
							value={formData.gender || ""}
							className="option_container"
							onChange={handleChange}
						>
							<option	value="male" className="form_option">Male</option>
							<option	value="female" className="form_option">Female</option>
						</select>
					</label>

					<label>
						Role:
						<select
							id="role"
							name="role"
							value={formData.role || ""}
							className="option_container"
							onChange={handleChange}
						>
							<option	value="user" className="form_option">User</option>
							<option	value="admin"	className="form_option">Admin</option>
						</select>
					</label>

					<label>
						Address:
						<input
							type="text"
							name="address"
							value={formData.address || ""}
							onChange={handleChange}
							className="input_area"
							placeholder="Enter your address"
						/>
					</label>
				</div>

				<button	type="submit"	className="btn_primary btn_auth" >Save Changes</button>
			</form>
		</div>
	);
};

export default ModalEditUser;
